import {
  ThunkAction,
  Action,
  configureStore,
  combineReducers
} from "@reduxjs/toolkit";
// import thunkMiddleware from "redux-thunk";
import rootReducer from "./reducers";
import sessionStorage from "redux-persist/lib/storage/session";
import type { PreloadedState } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
// export const store = configureStore({
//   reducer: rootReducer,
//   middleware: [thunkMiddleware]
// });

// export type AppDispatch = typeof store.dispatch;
// export type AppState = ReturnType<typeof store.getState>;
// export type AppThunk<ReturnType = void> = ThunkAction<
//   ReturnType,
//   AppState,
//   unknown,
//   Action<string>
// >;

const persistConfig = {
  key: "root",
  storage: sessionStorage,
  blacklist: ["config"]
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const setupStore = (preloadedState?: PreloadedState<RootState>) => {
  return configureStore({
    reducer: persistedReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: true,
        serializableCheck: false,
        immutableCheck: false
      })
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
